export default __webpack_public_path__ + "static/media/zvet.4dfacee7.webp";